import { useRef, useCallback } from 'react';

import { useHeaderActions } from '~contexts/HeaderActionsContext';

export interface UseCompleteInitialConfigReturn {
  isCompleteConfig: boolean;
  setCompletedConfig: (isCompleteConfig: boolean) => void;
  handleOpenMenuFirstStepOnCompleted: () => void;
}

export const useCompleteInitialConfig = (): UseCompleteInitialConfigReturn => {
  const {
    menuFirstSteps: {
      handleToggleOpenMenu: menuFirstStepsHandleToggleOpenMenu,
    },
  } = useHeaderActions();

  const completeConfigRef = useRef(false);

  const setCompletedConfig = useCallback((isCompleteConfig: boolean) => {
    completeConfigRef.current = isCompleteConfig;
  }, []);

  const handleOpenMenuFirstStepOnCompleted = useCallback(() => {
    if (completeConfigRef.current) {
      setTimeout(() => {
        menuFirstStepsHandleToggleOpenMenu(true);
      }, 1000);
    }
  }, [menuFirstStepsHandleToggleOpenMenu]);

  return {
    isCompleteConfig: completeConfigRef.current,
    setCompletedConfig,
    handleOpenMenuFirstStepOnCompleted,
  };
};
